(function () {
    'use strict';

    angular
        .module('iMatApp')
        .factory('mainWorkflow', mainWorkflow);

    mainWorkflow.$inject = ['$log', 'upload3DModelStateManager', 'materialsManager', 'promoMessageManager', 'upload3DModelAccessManager', 'mainWorkspace'];

    function mainWorkflow($log, stateManager, materialsManager, promoMessageManager, accessManager, mainWorkspace) {
        return {
            setup: setup
        };

        function setup($scope) {
            $log.debug("Start setup main workflow.");

            restoreState();

            stateManager.runWorkspaceWatching($scope);
            materialsManager.runProductWatching($scope);
            promoMessageManager.runProductWatching($scope);
            accessManager.runProductTemplateWatching($scope);

            $log.debug("End setup main workflow.");
        }

        function restoreState() {
            mainWorkspace.product = stateManager.restoreProduct();
            mainWorkspace.options = stateManager.restoreOptions();
            $log.debug("Product and options restored.");
        }
    }
}());